import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AllPageService } from "src/app/shared/services/all-page.service";
import * as moment from "moment";

declare  var jQuery:  any;
declare var $: any; 

@Component({
  selector: 'app-player-single',
  templateUrl: './player-single.component.html',
  styleUrls: ['./player-single.component.scss']
})
export class PlayerSingleComponent implements OnInit {
	currentYear: number = new Date().getFullYear();
	detailplayerRequest: any = {};
	playerSingle: any = {};
	playerid: any = 0;
	team_type: any = "";
	previous_data: boolean = false;
  	next_data: boolean = false;
	nextRequest: any = {};
	previousRequest: any = {};
	playerNext: any = {};
  	playerPrevious: any = {};

  constructor(
	  private allpagesService: AllPageService,
	private activatedRoute:ActivatedRoute,) { }

  ngOnInit() {

	this.activatedRoute.params.subscribe((data)=>{
		if(data.slug){
		  this.getPlayerlist(data.slug);
		  //this.newsRequest = data.slug;
		}
	  });
    jQuery(".courses-name").click(function(){
	    if(jQuery(this).hasClass('active')){
	        // do nothing
	    }else{
	        var tabid = jQuery(this).attr('id');
	        jQuery(".courses-name").removeClass('active');
	        jQuery(this).addClass('active');
	        jQuery(".course-main-content").removeClass('active');
	        jQuery("#"+tabid+"-content").addClass("active");
	    }
	    return false;
	});
	
	jQuery(".player-single-bottom-tab ul li").click(function(){
	  jQuery(".player-single-center-section").toggleClass("intro");
	});
  }

  getPlayerlist(playerslug) {
    this.detailplayerRequest.slug = playerslug;
    let request = Object.assign({}, this.detailplayerRequest)
    this.allpagesService.getPlayerDetails(request).then((data) => {
       this.playerSingle = data.data || {};
	   this.playerid = data.data.players_id;
	   this.team_type = data.data.team_type;
	   this.nextPlayers(this.playerid, this.team_type);
       this.previousPlayers(this.playerid, this.team_type);
	   setTimeout(() => {
			jQuery(".career-name").click(function(){
				if(jQuery(this).hasClass('active')){
					// do nothing
				}else{
					var tabid = jQuery(this).attr('id');
					jQuery(".career-name").removeClass('active');
					jQuery(this).addClass('active');
					jQuery(".career-main-content").removeClass('active');
					jQuery("#"+tabid+"-content").addClass("active");
				}
				return false;
			});
		}, 1000);
       
       console.log(this.playerSingle);
      
      });
  }
  nextPlayers(id, team) {
    this.nextRequest = { 
      players_id: id,
	  team_type: team,
      is_recored: 'Next'
    }
    let request = Object.assign({}, this.nextRequest)
    this.allpagesService.getNextplayers(request).then((data : any) => {
       this.playerNext = data.data || {};
       //console.log(data);
       if(data.status ==1){
         console.log(this.playerNext);
         this.next_data = true;
       }else{
         this.next_data = false;
       }
       
      });
  }
  previousPlayers(id, team) {
    this.previousRequest = {
      players_id: id,
	  team_type: team,
      is_recored: 'Prev'
    }
    let request = Object.assign({}, this.previousRequest)
    this.allpagesService.getPreviousplayers(request).then((data) => {
       this.playerPrevious = data.data || {};
       if(data.status ==1){
         console.log(this.playerPrevious);
         this.previous_data = true;
       }else{
         this.previous_data = false;
       }
      });
  }

}
